import React from 'react';
import CapitalBridge from '@di-shared/features/capital/CapitalBridge';

export interface CapitalBridgePageProps {
  vin: string;
}

function CapitalBridgePage({vin}: CapitalBridgePageProps) {
  return <CapitalBridge vin={vin} />;
}

export default CapitalBridgePage;
